import Queries from 'src/services/graphql/queries/index';
import { UnitSensorInput } from 'src/services/graphql/Models';
import UnitSensor from './classes/UnitSensor';
import DataStoreExtension from './generic/datastore';
import { DocumentNode } from 'graphql';
import authStore from '../authStore';
import { getFirstKey } from 'src/shared/utility';

export class UnitSensorStore extends DataStoreExtension<UnitSensorInput, UnitSensor> {
    listQueries: DocumentNode =  Queries.ListUnitSensors;
    
    _createQueries = Queries.CreateUnitSensor;
    _updateQueries = Queries.UpdateUnitSensorClient;
    _deleteQueries = Queries.DeleteUnitSensor;
    _allSubscriptions = () => {
        return [
            {
                document: Queries.UnitSensorSubscription,
                updateQuery: (prev, { subscriptionData }) => {
                    let newItem = subscriptionData.data;
                    
                    let prevKey = getFirstKey(prev);
                    let newItemsIndex = getFirstKey(newItem);
                    
                    if (
                        prevKey === false ||
                        newItemsIndex === false ||
                        authStore.clientId !==
                            newItem[newItemsIndex].clientId
                    ) { 
                        return prev;
                    }
                    
                    newItem = newItem[newItemsIndex];
                    
                    let { items } = prev[prevKey];
                    let itemIndex = items.findIndex(o => o.typedId === newItem.typedId);
                    
                    newItem.__typename = 'UnitSensor';
                    
                    // let actualSymbol = 
                    // `$ROOT_QUERY.listUnitSensors(${JSON.stringify(reduce(this.listVariables))})`;
                    let _items;
                    if (
                        itemIndex >= 0 &&
                        itemIndex < items.length
                    ) {
                        _items = [
                            ...items.slice(0, itemIndex),
                            Object.assign({}, items[itemIndex], newItem),
                            ...items.slice(itemIndex + 1, items.length)
                        ];
                    } else {
                        newItem.name = newItem.typedId.split(':')[1];
                        newItem.configurations = [];
                        _items = [newItem, ...items];
                    }

                    let ret = Object.assign({}, prev, {
                        [prevKey]: {
                            ...prev[prevKey],
                            items: _items, 
                        }
                    });
                    return ret;
                }
            }
        ];
    }

    listVariables: any = () => ({
        input:  {
            clientId: authStore.clientId,
            typedId: 'us'
        }
    })

    constructor() {
        super(false);
        this.subscriptionToUpdate(this.updateTypedItem('us', 'listUnitSensors'));
    }

    toObject(from: UnitSensorInput, index: number, array: UnitSensorInput[]): UnitSensor {
        return new UnitSensor(from, index, array);
    }

    countError(obj: UnitSensorInput) {
        let errors = [];
        return errors;
    }

    parseDelete(obj: UnitSensor) {
        return this.parseUnitDelete(obj);
    }
}

export default new UnitSensorStore();


// WEBPACK FOOTER //
// ./src/stores/application/unitsensor.ts